import { useEffect, useState } from 'react'

// 0 → 1 con ease-out cuando `ready` pasa a true (animación de "conquista" al cargar).
export default function useReveal(ready, ms = 1800) {
  const [t, setT] = useState(0)
  useEffect(() => {
    if (!ready) return
    let raf
    const start = performance.now()
    const step = now => {
      const k = Math.min(1, (now - start) / ms)
      setT(1 - Math.pow(1 - k, 3))
      if (k < 1) raf = requestAnimationFrame(step)
    }
    raf = requestAnimationFrame(step)
    return () => cancelAnimationFrame(raf)
  }, [ready, ms])
  return t
}
